import { render, staticRenderFns } from "./BulkCommandAdd.vue?vue&type=template&id=6874a946&scoped=true&"
import script from "./BulkCommandAdd.vue?vue&type=script&lang=js&"
export * from "./BulkCommandAdd.vue?vue&type=script&lang=js&"
import style0 from "./BulkCommandAdd.vue?vue&type=style&index=0&id=6874a946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874a946",
  null
  
)

export default component.exports